import HTMLReactParser from "html-react-parser";
import React, { useEffect, useState } from "react";
import { ArcherContainer, ArcherElement, Relation } from 'react-archer';
import { useDispatch, useSelector } from "react-redux";
import { DragescentState } from "../../../../store/reducers/stateType";
import { investTechPoint } from "../../../../store/actions/technology";
import { DevelopmentType } from "../../../../lib/types";
import { getData } from "../../../../lib/commonFunctions";
import { updateDevelopment } from "../../../../store/actions";
import InnerLoader from "../../../Common/InnerLoader";
// import DialogButton from "../../../Common/DialogButton";
// import { icons } from "../../../../assets/images/icons";
// import { Upgrade } from "../../../../lib/types";
// import { UPGRADES } from "../../../../lib/enums";

const colors = {
  orc: "#eded3e",
  djinn: "#e731e1",
  vampire: "#e62f2f",
  dwarf: "#8a81ff"
}

const Development = () => {
  const development = useSelector((state: DragescentState) => state.governorate.development);
  const race = useSelector((state: DragescentState) => state.governorate.race);
  const warCount = useSelector((state: DragescentState) => state.governorate.warCount);
  let rows: DevelopmentType[] = [];
  const Race: "orc" | "djinn" | "vampire" | "dwarf" = useSelector(
    (state: DragescentState) => state.governorate.race.name
  );
  // const credits = useSelector((state: DragescentState) => state.governorate.player.credits);
  // const resetTechnology = useSelector((state: DragescentState) => state.governorate.upgrades
  //   .find((u: Upgrade) => u.id === UPGRADES.ResetDevelopment));
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<number | null>(null);
  const [selectedPath, setSelectedPath] = useState<number[] | null>(null);
  console.log(development);

  useEffect(() => {
    if (!development.developments) {
      getData(`/api/development`)
        .then((developmentData) => {
          dispatch(updateDevelopment(developmentData.development))
        });
    }
  }, [])

  // rows.forEach((_, index) => {
  //   const columns: DevelopmentType[] = development.developments
  //   .filter((d: DevelopmentType) => d.row === index + 1)
  //     .sort((d1: DevelopmentType, d2: DevelopmentType) => d1.column - d2.column);
  //   columns.forEach((d, i) => {
  //     while ()
  //   })
  // });
  console.log(rows);

  if (development.developments) {
    rows = Array(Math.max(...development.developments
      .map((d: DevelopmentType) => d.row))).fill({});
    console.log(rows);
    development.developments.forEach((d: DevelopmentType) => {
      console.log(`element ${d.id} ${d.row} ${d.column}`);
      console.log(rows[d.row - 1]);
      const row = {
        ...rows[d.row - 1],
        [d.column]: d
      }
      rows[d.row - 1] = row;
    });
  }

  const isDevelopmentUnlocked = (devId: number) => development?.unlockDevelopments.includes(devId);

  const isDevelopmentAvailable = (dev: DevelopmentType) => ((dev.id !== 32 || !!warCount)
    && (dev.id !== 51 || warCount > 1) && (dev.id !== 83 || warCount > 2))
    && dev.requiredDevelopments
      .every(reqDev => (!reqDev.requiredDevelopmentId
        || development?.unlockDevelopments.includes(reqDev.requiredDevelopmentId))
        && (!reqDev.exclusive || development?.developments
          .some((d: DevelopmentType) => d.exclusive === reqDev.exclusive
            && development?.unlockDevelopments.includes(d.id))))
    && (!dev.exclusive || development.developments
      .every((d: DevelopmentType) => d.exclusive !== dev.exclusive
        || !development?.unlockDevelopments.includes(d.id)));

  const handleSelectPath = (selectedDev: DevelopmentType | null) => {
    if (!selectedDev) {
      setSelected(null);
      setSelectedPath(null);
      return;
    }

    setSelected(selectedDev.id);

    const walkSelectedPath = (selDev: DevelopmentType): number[] => {
      console.log(`checking path ${selDev.id}`);
      const path = selDev.requiredDevelopments?.map(d => (d.exclusive
        && development.developments?.filter((d1: DevelopmentType) => d1.exclusive === d.exclusive)
          .map((d1: DevelopmentType) => d1.id)) || d.requiredDevelopmentId).flat();

      return [...path, ...(path.length
        ? path.map(id => walkSelectedPath(
          development.developments?.find((d2: DevelopmentType) => d2.id === id)
        )).flat()
        : [])];
    }

    setSelectedPath(walkSelectedPath(selectedDev));
  }

  // const isOnSelectedPath = (pathDev: DevelopmentType): boolean => {
  //   console.log(`isOnSelectedPath ${selected} ${pathDev.id}`);
  //
  //   if (selected === null) {
  //     return false;
  //   }
  //
  //
  //   const requiredIds = development.developments
  //     .filter((dev: DevelopmentType) => dev.dependantDevelopments
  //       .some(depDev => depDev.developmentId === selected)).map((d: DevelopmentType) => d.id);
  //   console.log(requiredIds);
  //   return requiredIds.includes(pathDev.id)
  //     || (pathDev?.dependantDevelopments && pathDev.dependantDevelopments
  //       .map(d => development.developments
  //         .find((d1: DevelopmentType) => d.developmentId === d1.id))
  //       .some((req: DevelopmentType) => req && isOnSelectedPath(req)));
  // }

  const getRelations = (
    dev: DevelopmentType
  ): Relation[] => ([
    ...dev.dependantDevelopments,
    ...dev.dependantExclusive.filter(d => d.exclusive !== null)
  ] || [])
    .map(depDev => ({
      targetId: depDev.developmentId.toString(10),
      targetAnchor: dev.row === development
        .developments?.find((d: DevelopmentType) => d.id === depDev.developmentId)?.row
        ? (dev.id > depDev.developmentId ? "right" : "left")
        : (dev.id > depDev.developmentId ? "bottom" : "top"),
      sourceAnchor: dev.row === development
        .developments?.find((d: DevelopmentType) => d.id === depDev.developmentId)?.row
        ? (dev.id > depDev.developmentId ? "left" : "right")
        : (dev.id > depDev.developmentId ? "top" : "bottom"),
      style: {
        strokeColor: depDev.developmentId === selected
        || selectedPath?.includes(depDev.developmentId)
          ? colors[Race] : "#3e3e3e",
        strokeWidth: 1
      }
    }));

  return (
    <>
      <section className="first boxes-group">
        <div className="box first text-center padding">
          <h2 className="h1 text-capitalize case-sensitive spacer">{development.points} free technology points</h2>
          <p className="progress-bar">
            <span className="progress positive" style={{ width: `${Math.floor(100 * development.partial / 100)}%` }}/>
          </p>
          <p className="positive">Next development point {development.partial} / 100</p>
          {/* <div> */}
          {/*  <span>Reset</span> */}
          {/*  <DialogButton */}
          {/*    dialogOptions={{ */}
          {/*      name: "PurchaseUpgrade", */}
          {/*      header: "Reset technology", */}
          {/*      id: resetTechnology.id, */}
          {/*      question: "Reset invested technology points?", */}
          {/*      purchasable: !(credits < resetTechnology.price), */}
          {/*      price: resetTechnology.price */}
          {/*    }} */}
          {/*  > */}
          {/*    GET <img src={icons.credit} alt=""/> */}
          {/*  </DialogButton> */}
          {/* </div> */}
        </div>
        <span className="divider"/>
      </section>
      <section className="boxes-group">
        {development.developments ? <div className={"box"}>
          <div style={{ overflowX: "scroll", display: "flex" }}>
            <ArcherContainer noCurves={true}>
              {
                rows.map((r, rowIndex) => (
                  <div className={"row"} key={`row-${rowIndex}`} style={{
                    display: "flex",
                    justifyContent: "center"
                  }}>
                    {Object.values(r).map((dev: any) => <div
                      // className={`${Object.values(r).length < 6
                      //   ? "col-md-25"
                      //   : (Object.values(r).length > 6 ? "" : "col-md-2")} person-col`}
                      className={"person-col"}
                      style={{ width: "14.285%", minWidth: "140px" }}
                    >
                      <ArcherElement
                        id={dev.id}
                        relations={getRelations(dev)}
                      >
                        <div
                          className={`person ${isDevelopmentUnlocked(dev.id)
                          || (dev.id === selected || selectedPath?.includes(dev.id))
                            ? "selected" : ""}`}
                          style={{
                            minHeight: "231px",
                            height: "231px",
                            display: "flex",
                            flexFlow: "column"
                          }}
                          onClick={() => handleSelectPath(selected === dev.id ? null : dev)}
                        >
                          <em style={{
                            position: "absolute",
                            top: "18px",
                            left: "18px"
                          }}>{dev.id}</em>
                          <div style={{ paddingTop: "8px" }}>
                            {HTMLReactParser(dev.description)}
                          </div>
                          {[32, 51, 83].includes(dev.id) && <div style={{ paddingTop: "8px" }}>
                            <em>
                              Requires {dev.id === 32 ? "1 war" : `${dev.id === 51 ? "2" : "3"} wars`}
                            </em>
                          </div>
                          }
                          <div style={{
                            paddingTop: "8px",
                            height: "100%",
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "center"
                          }}>
                            <strong style={{ paddingRight: "4px" }}>
                              {dev.points}
                            </strong> <i className="icon icon-sm align-sub icon-vedci"/>
                          </div>
                          <div style={{
                            paddingTop: "16px",
                            height: "50px",
                            display: "flex",
                            alignItems: "end",
                            marginBottom: "34px"
                          }}>
                            {dev.exclusive !== null ? <small
                              style={{
                                lineHeight: "14px",
                                fontStyle: "inherit",
                                fontSize: "80%"
                              }}
                            >Exclusive with: <b>{
                              dev.id === 42 ? <span style={{ paddingRight: "4px" }}>16</span>
                                : (dev.id === 43
                                  ? <span style={{ paddingRight: "4px" }}>17</span> : <></>)
                            }
                              {development.developments?.filter(
                                (d: DevelopmentType) => d.id !== dev.id
                                  && d.exclusive === dev.exclusive
                              ).map((d: DevelopmentType) => <span style={{ paddingRight: "4px" }}>
                            {d.id}
                          </span>)}</b></small> : <>&nbsp;</>}
                          </div>
                          {!isDevelopmentUnlocked(dev.id) && <div
                            style={{ position: "absolute", bottom: "23px" }}
                          >
                            <a
                              className={`btn btn-blank btn-no-width ${isDevelopmentAvailable(dev)
                              && development.points >= dev.points ? "" : "disabled"}`}
                              onClick={() => isDevelopmentAvailable(dev)
                                && development.points >= dev.points
                                && dispatch(investTechPoint(dev.id))}
                            >
                              INVEST
                            </a>
                          </div>}
                        </div>
                      </ArcherElement>
                    </div>)}
                  </div>
                ))
              }
              {/* { */}
              {/*  Array(Math.ceil(development.developments.length / 5)).fill("") */}
              {/*    .map((_, index) => <div className={"row"}>{development.developments */}
              {/*      .slice(index * 5, (index + 1) * 5) */}
              {/*      .map((dev: any) => <div className={"col-md-25 person-col"}> */}
              {/*        <ArcherElement */}
              {/*          id={dev.id} */}
              {/*          relations={getRelations(dev, false)} */}
              {/*        > */}
              {/*          <div */}
              {/*            className={`person ${isDevelopmentUnlocked(dev.id) */}
              {/*            || (selected !== null && false) ? "selected" : ""}`} */}
              {/*            style={{ minHeight: "150px", height: "150px" }} */}
              {/*            onClick={() => setSelected(selected === dev.id ? null : dev.id)} */}
              {/*          > */}
              {/*            <div><em>{dev.id}</em> {HTMLReactParser(dev.description)}</div> */}
              {/*            <div>Points: {dev.points}</div> */}
              {/*            {!isDevelopmentUnlocked(dev.id) && <div><a */}
              {/*              className={`btn btn-blank btn-no-width
          ${isDevelopmentAvailable(dev) ? "" : "disabled"}`} */}
              {/*              onClick={() => isDevelopmentAvailable(dev) */}
              {/*                && dispatch(investTechPoint(dev.id))} */}
              {/*            > */}
              {/*              INVEST */}
              {/*            </a></div>} */}
              {/*          </div> */}
              {/*        </ArcherElement> */}
              {/*      </div>)} */}
              {/*    </div>) */}
              {/* } */}
            </ArcherContainer>
          </div>
        </div> : <InnerLoader race={race.name} />}
        <span className="divider"/>
      </section>
    </>
  )
}

export default Development;
